"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const translationContext_1 = require("configs/translationContext");
const useInputBlur_1 = __importDefault(require("hooks/useInputBlur"));
const useInputChange_1 = __importDefault(require("hooks/useInputChange"));
require("@hotmart/cosmos/dist/dropdown");
require("@hotmart/cosmos/dist/select");
const BaseSelect = ({ className = '', dataTestId = 'input-select-component', disabled = false, hasError = false, hasSearch = true, id, inputClassName, label = '', labelClassName, loading = false, noResultText, onBlur, onChange, placeholder = '', value = '', children }) => {
    const { t } = (0, translationContext_1.useTranslation)();
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const inputSelectRef = (0, react_1.useRef)(null);
    const labelId = `${id}-label`;
    (0, useInputBlur_1.default)(inputSelectRef, onBlur);
    (0, useInputChange_1.default)(inputSelectRef, onChange);
    (0, react_1.useEffect)(() => {
        var _a, _b, _c;
        const searchInput = (_c = (_b = (_a = inputSelectRef.current) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector) === null || _c === void 0 ? void 0 : _c.call(_b, '#dropdown-input');
        if (searchInput) {
            searchInput.autocomplete = 'off';
            searchInput.readOnly = !hasSearch;
        }
    }, [hasSearch]);
    (0, react_1.useEffect)(() => {
        if (inputSelectRef.current) {
            inputSelectRef.current._changeInputText = function _changeInputText() {
                if (this._input) {
                    const option = this.querySelector('hot-select-option[selected]');
                    this._input.value =
                        (option === null || option === void 0 ? void 0 : option.getAttribute('aria-label')) || (option === null || option === void 0 ? void 0 : option.textContent) || '';
                }
            };
            inputSelectRef.current._changeInputText();
        }
    }, []);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        (_a = inputSelectRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('open', () => {
            setIsOpen(true);
        });
        (_b = inputSelectRef.current) === null || _b === void 0 ? void 0 : _b.addEventListener('close', () => {
            setIsOpen(false);
        });
    }, []);
    const getOptionOptionalProps = (0, react_1.useCallback)((option) => {
        const optionalProps = {
            'aria-selected': false
        };
        if (String(option.value) === String(value)) {
            optionalProps.selected = '';
            optionalProps['aria-selected'] = true;
        }
        if (option['aria-label']) {
            optionalProps['aria-label'] = option['aria-label'];
        }
        return optionalProps;
    }, [value]);
    const getSelectOptionalProps = () => {
        const optionalProps = {
            'text-no-results': noResultText || t('general.no_result_found')
        };
        if (hasError) {
            optionalProps.invalid = '';
        }
        if (disabled) {
            optionalProps.disabled = '';
        }
        if (loading) {
            optionalProps.loading = '';
        }
        if (label) {
            optionalProps['aria-labelledby'] = labelId;
        }
        return optionalProps;
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)('hot-form', className), children: [label && ((0, jsx_runtime_1.jsx)("label", { id: labelId, htmlFor: id, className: (0, classnames_1.default)('hot-form__label', labelClassName), children: label })), (0, jsx_runtime_1.jsx)("hot-select", { id: id, ref: inputSelectRef, value: value, class: (0, classnames_1.default)('_w-full', inputClassName), placeholder: placeholder, "data-testid": dataTestId, role: "combobox", "aria-expanded": isOpen, ...getSelectOptionalProps(), children: (0, jsx_runtime_1.jsx)("div", { className: "_hot-scroll", role: "listbox", "aria-labelledby": labelId, children: children({ getOptionOptionalProps }) }) })] }));
};
exports.default = BaseSelect;
